export default __webpack_public_path__ + "static/media/comparison-nova.a09ce8a5.jpg";